export const elementReady = (selector) =>
	new Promise((resolve) => {
		const el = document.querySelectorAll(selector);
		if (el.length) {
			resolve(el);
			return;
		}
		new MutationObserver(() => {
			// Query for elements matching the specified selector
			Array.from(document.querySelectorAll(selector)).forEach((element) => {
				resolve(element);
			});
		}).observe(document.documentElement, {
			childList: true,
			subtree: true,
		});
	});
